<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout row wrap pa-3>
          <v-flex lg6 md6 sm12>
            <v-text-field
              :disabled="!roleEditable || currentCustomer.ID > 0"
              label="Tên đăng nhập"
              v-model="currentCustomer.Username"
              class="input-group--focused"
              :rules="nameRules"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Mã khách hàng"
              v-model="currentCustomer.UserCode"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Họ"
              v-model="currentCustomer.FirstName"
              class="input-group--focused"
              :rules="requireRules"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Tên"
              v-model="currentCustomer.LastName"
              class="input-group--focused"
              :rules="requireRules"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-layout row>
              <v-flex lg12>
                <v-text-field
                  label="Điện thoại"
                  v-model="currentCustomer.PhoneNumber"
                  class="input-group--focused"
                  :rules="requireRules"
                  :disabled="!canViewPhoneNumber"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Email"
              v-model="currentCustomer.Email"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-text-field
              label="Địa chỉ"
              v-model="currentCustomer.Address"
              class="input-group--focused"
              :rules="requireRules"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md12 sm12>
            <v-select
              label="Kho TQ"
              class="input-group--focused"
              :items="chinaStores"
              v-model="currentCustomer.ChinaStoreID"
              item-text="Name"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg6 md12 sm12>
            <v-select
              label="Kho VN"
              class="input-group--focused"
              :items="warehouses"
              v-model="currentCustomer.ReceivePlaceID"
              item-text="Name"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Nhân viên CSKH"
              :items="cs_staffs"
              v-model="currentCustomer.CustomerServiceID"
              item-text="FullName"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Nhân viên đặt hàng"
              :items="p_staffs"
              v-model="currentCustomer.BuyerID"
              item-text="FullName"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Nhân viên Sale"
              :items="sale_staffs"
              v-model="currentCustomer.SalerID"
              item-text="FullName"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Nhân viên chứng từ"
              :items="officer_staffs"
              v-model="currentCustomer.OfficerID"
              item-text="FullName"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Level"
              :items="levels"
              v-model="currentCustomer.LevelID"
              item-text="VIPName"
              item-value="ID"
              :rules="requireRules"
            ></v-select>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Trạng thái"
              :items="customerStatus"
              v-model="currentCustomer.Status"
              item-text="name"
              item-value="value"
              :rules="requireRules"
            ></v-select>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <h-currency-input
              :disabled="!roleEditable"
              label="Công nợ tối đa"
              :decimal="0"
              v-model="currentCustomer.MaxDebt"
            ></h-currency-input>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-switch
              v-model="currentCustomer.IsSpecialFee"
              label="Áp dụng mức phí đặc biệt (đặt -1 để tính theo mặc định)"
              class="input-group--focused"
              :disabled="!roleEditable"
            ></v-switch>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <v-text-field
              type="number"
              :disabled="!currentCustomer.IsSpecialFee || !roleEditable"
              step=".1"
              v-model="currentCustomer.FeeBuy"
              label="Phí mua hàng (%)"
            ></v-text-field>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <v-text-field
              type="number"
              :disabled="!roleEditable"
              step=".1"
              v-model="currentCustomer.FeeUTNKPercent"
              label="Phí UTNK (%)"
            ></v-text-field>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <v-text-field
              type="number"
              :disabled="!currentCustomer.IsSpecialFee || !roleEditable"
              step="1"
              v-model="currentCustomer.FeeWeight"
              label="Phí cân nặng"
            ></v-text-field>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <v-text-field
              type="number"
              :disabled="!currentCustomer.IsSpecialFee || !roleEditable"
              step="1"
              v-model="currentCustomer.FeeVolumn"
              label="Phí khối"
            ></v-text-field>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <v-text-field
              type="number"
              :disabled="!roleEditable"
              step="1"
              v-model="currentCustomer.RateDiscount"
              label="Chiết khấu tỷ giá"
            ></v-text-field>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-switch
              :disabled="!roleEditable"
              v-model="currentCustomer.FinanceApproved"
              :true-value="1"
              :false-value="0"
              label="Duyệt tài chính"
              class="input-group--focused"
            ></v-switch>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-switch
              :disabled="!roleEditable"
              v-model="currentCustomer.IsWeightByVolume"
              label="Tính cân quy đổi"
              class="input-group--focused"
            ></v-switch>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-switch
              :disabled="!roleEditable"
              v-model="currentCustomer.IsDepositRate"
              label="Áp dụng tỷ lệ cọc"
              class="input-group--focused"
            ></v-switch>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              :disabled="!currentCustomer.IsDepositRate || !roleEditable"
              :decimal="0"
              v-model="currentCustomer.DepositRate"
              label="Tỷ lệ cọc (%)"
            ></h-currency-input>
          </v-flex>
          <!-- Thông tin pháp nhân Xuất nhập khẩu (Hóa đơn VAT) -->
          <v-flex xs12>
            <v-divider class="my-4"></v-divider>
            <h3 class="title mb-3">Thông tin pháp nhân Xuất nhập khẩu</h3>
          </v-flex>

          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Mã hợp đồng nguyên tắc"
              v-model="currentCustomer.ContractCode"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Ngày hợp đồng nguyên tắc"
              v-model="currentCustomer.ContractDate"
              type="date"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>

          <v-flex lg2 md2 sm12>
            <v-select
              label="Ông/Bà"
              :items="genders"
              v-model="currentCustomer.Gender"
              item-text="text"
              item-value="value"
              class="input-group--focused"
            ></v-select>
          </v-flex>
          <v-flex lg5 md5 sm12>
            <v-text-field
              label="Người Đại Diện"
              v-model="currentCustomer.VatRepresentative"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg5 md5 sm12>
            <v-text-field
              label="Chức danh"
              v-model="currentCustomer.Title"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <v-text-field
              label="Mã Số Thuế"
              v-model="currentCustomer.VatTaxCode"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg5 md5 sm12>
            <v-text-field
              label="Tên Đơn Vị/Công Ty"
              v-model="currentCustomer.VatCompanyName"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg5 md5 sm12>
            <v-text-field
              label="Địa Chỉ"
              v-model="currentCustomer.VatAddress"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Số Tài Khoản"
              v-model="currentCustomer.VatAccountNumber"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Nhận Bằng Email"
              v-model="currentCustomer.VatEmail"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>

          <!-- Files đính kèm (CCCD, DKKD) -->
          <v-flex lg4 md4 sm12>
            <v-card outlined class="pa-3">
              <div class="subtitle-2 mb-2 font-weight-bold">Ảnh CCCD mặt trước</div>
              <v-layout align-center>
                <input
                  type="file"
                  ref="cccdFrontUploader"
                  style="display: none"
                  @change="uploadFile($event, 'CccdFront')"
                  accept="image/*,.pdf"
                />
                <v-btn
                  small
                  color="primary"
                  @click="$refs.cccdFrontUploader.click()"
                  :loading="uploading.CccdFront"
                  class="mr-2"
                >
                  <v-icon left>cloud_upload</v-icon> Tải file lên
                </v-btn>
                <v-btn
                  v-if="currentCustomer.CccdFront"
                  small
                  color="error"
                  outlined
                  @click="removeFile('CccdFront')"
                >
                  Xóa
                </v-btn>
              </v-layout>
              <div class="mt-2" v-if="currentCustomer.CccdFront">
                <a :href="currentCustomer.CccdFront" target="_blank">
                  <img
                    v-if="currentCustomer.CccdFront.match(/\.(jpeg|jpg|gif|png)$/i)"
                    :src="currentCustomer.CccdFront"
                    style="max-width: 100%; max-height: 120px; border-radius: 4px; border: 1px solid #ddd;"
                  />
                  <span v-else>Xem file đính kèm</span>
                </a>
              </div>
            </v-card>
          </v-flex>

          <v-flex lg4 md4 sm12>
            <v-card outlined class="pa-3">
              <div class="subtitle-2 mb-2 font-weight-bold">Ảnh CCCD mặt sau</div>
              <v-layout align-center>
                <input
                  type="file"
                  ref="cccdBackUploader"
                  style="display: none"
                  @change="uploadFile($event, 'CccdBack')"
                  accept="image/*,.pdf"
                />
                <v-btn
                  small
                  color="primary"
                  @click="$refs.cccdBackUploader.click()"
                  :loading="uploading.CccdBack"
                  class="mr-2"
                >
                  <v-icon left>cloud_upload</v-icon> Tải file lên
                </v-btn>
                <v-btn
                  v-if="currentCustomer.CccdBack"
                  small
                  color="error"
                  outlined
                  @click="removeFile('CccdBack')"
                >
                  Xóa
                </v-btn>
              </v-layout>
              <div class="mt-2" v-if="currentCustomer.CccdBack">
                <a :href="currentCustomer.CccdBack" target="_blank">
                  <img
                    v-if="currentCustomer.CccdBack.match(/\.(jpeg|jpg|gif|png)$/i)"
                    :src="currentCustomer.CccdBack"
                    style="max-width: 100%; max-height: 120px; border-radius: 4px; border: 1px solid #ddd;"
                  />
                  <span v-else>Xem file đính kèm</span>
                </a>
              </div>
            </v-card>
          </v-flex>

          <v-flex lg4 md4 sm12>
            <v-card outlined class="pa-3">
              <div class="subtitle-2 mb-2 font-weight-bold">Giấy phép DKKD</div>
              <v-layout align-center>
                <input
                  type="file"
                  ref="dkkdLicenseUploader"
                  style="display: none"
                  @change="uploadFile($event, 'DkkdLicense')"
                  accept="image/*,.pdf"
                />
                <v-btn
                  small
                  color="primary"
                  @click="$refs.dkkdLicenseUploader.click()"
                  :loading="uploading.DkkdLicense"
                  class="mr-2"
                >
                  <v-icon left>cloud_upload</v-icon> Tải file lên
                </v-btn>
                <v-btn
                  v-if="currentCustomer.DkkdLicense"
                  small
                  color="error"
                  outlined
                  @click="removeFile('DkkdLicense')"
                >
                  Xóa
                </v-btn>
              </v-layout>
              <div class="mt-2" v-if="currentCustomer.DkkdLicense">
                <a :href="currentCustomer.DkkdLicense" target="_blank">
                  <img
                    v-if="currentCustomer.DkkdLicense.match(/\.(jpeg|jpg|gif|png)$/i)"
                    :src="currentCustomer.DkkdLicense"
                    style="max-width: 100%; max-height: 120px; border-radius: 4px; border: 1px solid #ddd;"
                  />
                  <span v-else>Xem file đính kèm</span>
                </a>
              </div>
            </v-card>
          </v-flex>

          <v-flex sm12 md12 lg12>
            <v-widget title="Lịch sử giao dịch">
              <div slot="widget-content">
                <hpo-filter
                  :headers="tradeHeader"
                  :viewName="viewName"
                  v-on:applyFilter="applyFilter"
                  v-on:quickFilter="quickFilter"
                ></hpo-filter>
                <v-data-table
                  :headers="tradeHeader"
                  :items="trades"
                  :server-items-length="total_rows"
                  :options.sync="pagination"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        {{
                          item.CreatedDate | display_date("DD-MM-YYYY HH:mm:ss")
                        }}
                      </td>
                      <td>{{ item.HContent }}</td>
                      <td class="text-end">
                        {{ item.Type == 1 ? "-" : "+"
                        }}{{ item.Amount | currency }}
                      </td>
                      <td>{{ item.TradeType | trade_type }}</td>
                      <td class="text-end">{{ item.MoneyLeft | currency }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-widget>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import phonecode from "@/configs/phonecode";
import configs from "@/configs";
import md5 from "md5";
import { trade_type } from "@/commons/hpod";
import VWidget from "@/components/VWidget";
import Filtering from "@/components/Filtering";
import { makeid } from '@/commons/utils';
export default {
  filters: {
    trade_type,
  },
  components: {
    VWidget,
    "hpo-filter": Filtering
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      valid: true,
      pwdWarning: "Mật khẩu không khớp.",
      password: "",
      rePassword: "",
      uploading: {
        CccdFront: false,
        CccdBack: false,
        DkkdLicense: false
      },
      customerStatus: configs.CUSTOMER_STATUS_LIST,
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
      nameRules: [
        (v) => !!v || "Trường dữ liệu không được để trống.",
        (v) =>
          (v || "").indexOf(" ") < 0 ||
          "Tên đăng nhập không được chứa dấu cách",
        (v) => !/(?=.*[A-Z])/.test(v) || "Tên đăng nhập không được viết hoa",
        (v) =>
          /^[\x00-\x7F]*$/.test(v) ||
          "Tên đăng nhập chỉ bao gồm chữ cái a-z và số 0-9",
      ],
      genders: [
        { text: "Ông", value: 'Ông' },
        { text: "Bà", value: 'Bà' },
      ],
      tradeHeader: [
        {
          text: "Ngày giờ",
          value: "CreatedDate",
          sortable: true,
          filterable: true,
          quickSearch: false,
          dataType: dataType["Date"],
        },
        {
          text: "Nội dung",
          value: "HContent",
          sortable: true,
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"],
        },
        {
          text: "Số tiền",
          value: "Amount",
          align: "end",
          sortable: true,
          filterable: true,
          quickSearch: false,
          dataType: dataType["Number"],
        },
        {
          text: "Loại giao dịch",
          value: "TradeType",
          sortable: true,
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.TRADE_TYPE,
        },
        {
          text: "Số dư",
          value: "MoneyLeft",
          align: "end",
          sortable: true,
          filterable: true,
          quickSearch: false,
          dataType: dataType["Number"],
        },
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "historypaywallet",
      filterConditions: [],
      quickFilterConditions: [],
    };
  },
  computed: {
    ...mapState("customer", {
      loading: "loading",
      currentCustomer: "selected",
    }),
    ...mapState({
      trades: (state) => state.historypaywallet.all.data,
      total_rows: (state) => state.historypaywallet.all.total,
      warehouses: (state) => state.commons.stores,
      chinaStores: (state) => state.commons.chinaStores,
    }),
    ...mapState({
      levels: (state) => state.customerLevel.all.data,
      p_staffs: (state) =>
        _.filter(state.commons.all_users, function(o) {
          return (
            (o.RoleType & configs.ROLE_TYPE.Purchase) ==
            configs.ROLE_TYPE.Purchase
          );
        }),
      cs_staffs: (state) =>
        _.filter(state.commons.all_users, function(o) {
          return (
            (o.RoleType & configs.ROLE_TYPE.CustomerService) ==
            configs.ROLE_TYPE.CustomerService
          );
        }),
      sale_staffs: (state) =>
        _.filter(state.commons.all_users, function(o) {
          return (
            (o.RoleType & configs.ROLE_TYPE.Sale) ==
            configs.ROLE_TYPE.Sale
          );
        }),
      officer_staffs: (state) =>
        _.filter(state.commons.all_users, function(o) {
          return (
            (o.RoleType & configs.ROLE_TYPE.Officer) ==
            configs.ROLE_TYPE.Officer
          );
        }),
    }),
    customerId() {
      return this.$route.params.Pid;
    },
    prefixes() {
      return _.map(phonecode, "dial_code");
    },
    passwordConfirmationRule() {
      return this.password === this.rePassword || this.pwdWarning;
    },
    roleEditable() {
      return (
        (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment
      );
    },
    saleScopeIds() {
      const currentUser = this.$store.state.authentication.user;
      const userId = Number(currentUser.userid);
      const scopeIds = [userId];
      const currentStaff = this.$store.state.commons.all_users.find(user => Number(user.ID) === userId);
      if (currentStaff && Number(currentStaff.IsSaleLeader || 0) === 1) {
        this.$store.state.commons.all_users.forEach(user => {
          if (Number(user.SaleLeaderID) === userId) {
            scopeIds.push(Number(user.ID));
          }
        });
      }
      return scopeIds;
    },
    canViewPhoneNumber() {
      const currentUser = this.$store.state.authentication.user;
      const roleType = currentUser.roletype || 0;
      const isAdmin = (roleType & configs.ROLE_TYPE.Admin) === configs.ROLE_TYPE.Admin;
      const isSale = (roleType & configs.ROLE_TYPE.Sale) === configs.ROLE_TYPE.Sale;
      return isAdmin || (isSale && this.saleScopeIds.includes(Number(this.currentCustomer.SalerID)));
    },
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    },
    currentCustomer: {
      handler: function(val) {
        if (val) {
          if (val.FinanceApproved === undefined) {
            this.$set(val, 'FinanceApproved', 1);
          }
          if (val.ContractDate && val.ContractDate.length > 10) {
            this.$set(val, 'ContractDate', val.ContractDate.substring(0, 10));
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    filter_data: function() {
      if(this.customerId) {
        var param = {
          pagination: this.pagination,
          search_term: this.search,
          filter: this.filterConditions,
          quickFilter: this.quickFilterConditions,
        };
        param.filter.push({
          column: "UID",
          value: Number(this.customerId),
          condition: "equal",
        });
        this.$store.dispatch("historypaywallet/getList", param);
      } else {
        this.$store.commit("historypaywallet/setList", {});
      }
    },
    refreshData() {
      if (this.customerId > 0) {
        this.$store.commit("customer/setCustomerDetail", {data: {}});
        this.$store.commit("historypaywallet/setList", {data: []});
        this.$store.dispatch("customer/getCustomerDetail", {
          id: this.customerId,
          onSuccess: () => {
            this.filter_data();
          },
          onError: err => {
            if (err && (err.status === 403 || err.status === 404)) {
              this.$router.replace({ name: 'DataNotFound' });
            }
          }
        });
      }
      else {
        this.$store.commit("customer/setCustomerDetail", {data: {}});
        this.$store.commit("historypaywallet/setList", {data: []});
      }
    },
    resetPassword() {
      let random_password = makeid(10);
      this.currentCustomer.Password = md5(random_password);
      this.$store.dispatch("customer/setCustomerDetail", {
        data: this.currentCustomer,
        id: this.customerId,
        resetPwd: true,
        notify: 'Đã reset mật khẩu về mặc định (' + random_password + ')'
      });
    },
    saveData() {
      if (this.passwordConfirmationRule !== true) {
        window.getApp.$emit("APP_RESOURCE_FAILED", this.pwdWarning);
      }
      if (this.password !== "") {
        this.currentCustomer.Password = md5(this.password);
      }
      this.$store.dispatch("customer/setCustomerDetail", {
        data: this.currentCustomer,
        id: this.customerId,
      }).then(() => {
        window.getApp.$emit("APP_NAVIGATE", "CustomerList");
      }).catch((err) => {
        return;
      });
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    uploadFile(e, fieldName) {
      let file = e.target.files[0];
      if (!file) return;
      this.uploading[fieldName] = true;
      let formData = new FormData();
      formData.append("file", file);
      this.$http
        .post(`${configs.API || ""}/admin/api/upload/r2/`, formData, {
          headers: { Authorization: "Bearer " + this.$store.state.authentication.token }
        })
        .then(res => {
          this.uploading[fieldName] = false;
          if (res.data.status === 200 && res.data.data && res.data.data.url) {
            this.$set(this.currentCustomer, fieldName, res.data.data.url);
          } else {
            window.getApp.$emit("SHOW_NOTICE", "Upload thất bại: " + (res.data.message || res.data.error || ""), "error");
          }
        })
        .catch(err => {
          this.uploading[fieldName] = false;
          window.getApp.$emit("SHOW_NOTICE", "Lỗi kết nối khi upload file.", "error");
        });
      // reset file input
      e.target.value = "";
    },
    removeFile(fieldName) {
      this.$set(this.currentCustomer, fieldName, null);
    },
  },
  mounted() {
    this.refreshData();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_CREATE_DATA", this.resetPassword);
    this.$store.dispatch("commons/getAllUsers");
    let pagingReq = _.cloneDeep(configs.PAGINATION);
    pagingReq.sortDesc = [false];
    this.$store.dispatch("commons/getAllStores");
    this.$store.dispatch("commons/getAllChinaStores");
    this.$store.dispatch("customerLevel/getCustomerLevelList", {
      pagination: pagingReq,
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$off("REQUEST_CREATE_DATA", this.resetPassword);
  },
};
</script>

<style></style>
